import { useRecoilValue } from 'recoil';
import styled, { CSSProperties } from 'styled-components';
import { onBoardStateAtom } from '../OnBoardStep.atoms';

export const TOTAL_STEP = 10;

export default function Progress() {
  const onBoardState = useRecoilValue(onBoardStateAtom);
  if (onBoardState.step === TOTAL_STEP) return null;

  return (
    <Wrapper>
      <Box>
        <Bar width={`${(onBoardState.step / TOTAL_STEP) * 100}%`} />
      </Box>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 0.5rem 1.5rem;
  position: fixed;
  top: 58px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  background-color: var(--color-background);
  max-width: var(--max-width);
`;

const Box = styled.div`
  width: 100%;
  position: relative;
  height: 4px;
  background-color: ${({ theme }) => theme.palette.gray700};
`;

const Bar = styled.div<{ width: CSSProperties['width'] }>`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.palette.brand400};
  width: ${({ width }) => width};
  height: 100%;
  transition: width 0.3s;
`;
